/* @flow weak */
import ExternalAccountResourceStore from 'payments/stores/ExternalAccountResourceStore';
import Container from 'components/Container.jsx';
import DepositButton from 'payments/components/DepositButton.jsx';
import Money from 'payments/components/Money.jsx';
import Activity from 'entities/Activity';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/DepositSetupReceipt.scss';

const DepositSetupReceipt = ({ onDepositCompleted, activity }) => {
  const externalAccountResource = ExternalAccountResourceStore.getExternalAccountResources().first();
  const bankAccount = externalAccountResource.getBankAccount();
  return (
    <div className="DepositSetupReceipt">
      <Container size="medium">
        <div className="DepositSetupReceipt-header">
          <Text
            size="xxlarge"
            weight="semibold">
              Review and confirm your deposit information.
          </Text>
        </div>
        <div className="DepositSetupReceipt-accountInfoContainer">
          <div className="DepositSetupReceipt-accountName">
            <Text
              className="DepositSetupReceipt-accountInfoLabel"
              weight="light"
              color="pitch">
                Account Name:
            </Text>
            <Text
              truncate
              className="DepositSetupReceipt-accountInfo"
              weight="light"
              color="pitch">
              {bankAccount.getBankName()}
            </Text>
          </div>
          <div className="DepositSetupReceipt-routingNumber">
            <Text
              className="DepositSetupReceipt-accountInfoLabel"
              weight="light"
              color="pitch">Routing Number:
            </Text>
            <Text
              className="DepositSetupReceipt-accountInfo"
              weight="light"
              color="pitch">
              {bankAccount.getRoutingNumber()}
            </Text>
          </div>
          <div className="DepositSetupReceipt-accountNumber">
            <Text
              className="DepositSetupReceipt-accountInfoLabel"
              weight="light"
              color="pitch">
                Account Number:
            </Text>
            <Text
              className="DepositSetupReceipt-accountInfo"
              weight="light"
              color="pitch">
              ******{bankAccount.getAccountNumberLastFourDigits()}
            </Text>
          </div>
        </div>
        <div className="DepositSetupReceipt-total">
          <Text
            weight="semibold">
              Total Deposit
          </Text>
          <Text
            className="DepositSetupReceipt-accountInfo"
            weight="semibold">
            <Money cents={activity.getCurrentBalance()} />
          </Text>
        </div>
        <DepositButton
          className="DepositSetupReceipt-submit"
          activity={activity}
          amount={activity.getCurrentBalance()}
          account={bankAccount}
          onSuccess={onDepositCompleted}
        />
      </Container>
    </div>
  );
};

DepositSetupReceipt.propTypes = {
  onDepositCompleted: React.PropTypes.func.isRequired,
  activity: React.PropTypes.instanceOf(Activity).isRequired,
};

export default DepositSetupReceipt;



// WEBPACK FOOTER //
// ./src/payments/components/DepositSetupReceipt.jsx